<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          outlined
          label
          small
          :color="plano.status ? plano.status.color : 'primary'"
          dark
          v-bind="attrs"
          v-on="on"
          block
        >
          {{ plano.status?.descricao ?? "Aguardando Confirmação" }}
        </v-btn>
      </template>
      <v-list v-if="podeMostrarMenu">
        <v-list-item
          v-for="situacao of $constants.situacoesPlanos"
          :key="situacao.descricao"
          @click="() => atualizarSituacao(plano, situacao)"
          link
        >
          <v-list-item-title>
            <v-icon :color="situacao.cor" class="mr-2">mdi-circle</v-icon>
            {{ situacao.descricao ? situacao.descricao : "- - -" }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["plano"],
  computed: {
    ...mapGetters("Auth", ["user"]),
    userRole() {
      return this.user.role?.name || this.user.roleName || null;
    },
    podeMostrarMenu() {
      if (!this.userRole) return false;
      return this.$constants.rolesParaGestores.some((elem) => elem.name === this.userRole);
    },
  },
  methods: {
    async atualizarSituacao(plano, situacao) {
      const response = await this.$services.planosBimestraisService.update(plano.id, situacao.id);
      if (response) {
        this.$emit("update", response);
        this.$emit("close-modal");
      }
    },
    permitirRolesParaGestores() {
      try {
        // const userLocal = this.user.role ? this.user.role.name : [];
        // return this.$constants.rolesParaGestores.findIndex((elem) => {
        //   return elem.name === userLocal;
        // });
        const userLocal = this.user.roles ? this.user.roleName : [];
        return this.$constants.rolesParaGestores.findIndex((elem) => {
          return elem.name === userLocal;
        });
      } catch (error) {
        this.$handleError(error);
      }
      return false;
    },
  },
};
</script>
